












import { Component, Mixins } from "vue-property-decorator";
import { IQuotable } from "../../../../domain/document/items";
import { ModelEditableMixin } from "../../../system/mixins";

@Component({
})
export default class QuotationEditor extends Mixins(ModelEditableMixin) {
  editingSource: IQuotable;

  get shouldQuote(): boolean {
    return this.editingSource
      ? this.editingSource.shouldQuote && this.supportedQuotable
      : undefined;
  }

  set shouldQuote(value: boolean) {
    if (!this.supportedQuotable) {
      // disabledになるのでsetされることはないはずだが念のためガードしている
      return;
    }
    this.writeProperty(s => s.shouldQuote = value);
  }

  get supportedQuotable(): boolean {
    return this.editingSource
      ? this.editingSource.supportedQuotable
      : undefined;
  }
}
